var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onClick($event);
      }
    }
  }, [_c('forward-icon', {
    attrs: {
      "height": "75",
      "icon-name": "Next Activity",
      "width": "75"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }